// src/context/FormContext.jsx
import { createContext, useContext, useEffect, useReducer, useCallback, useMemo, useRef } from 'react';
import { REGISTROS_INICIAL } from '../utils/initialStates';
import { normalizarTipoSubsidio, parsearContactosObra } from '../utils/contactos';
import { TRAMITACIONES_INTERNAS_INICIAL } from '../utils/initialStates';
import { TRAMITACIONES_EXTERNAS_INICIAL } from '../utils/initialStates';
import { SELECTED_REQUISITOS_INICIAL } from '../utils/initialStates';
import { PAGO_PROYECTOS_INICIAL } from "../utils/initialStates";
import { PAGO_MEJORAS_INICIAL } from "../utils/initialStates";
import { PAGO_MICROCREDITOS_INICIAL } from "../utils/initialStates";
import { PAGO_INTERVENCIÓN_SOCIAL_INICIAL } from "../utils/initialStates";

const FormContext = createContext();

// Estado inicial
const initialState = {
			formA: {},
			formB: {},
			formC: {},
			dirtySections: {
				formA: false,
				formB_main: false,
				formB_observaciones: false,
				formB_expedienteProyecto: false,
				formB_tramitacionExterna: false,
				formC_main: false,
				formC_pagos: false,
				formC_mediciones: false,
				formC_mejoras: false,
				formC_geometries: false,
				formC_beneficiarios: false,
				formC_circuitoAdmin: false
			},
			dirtyFields: {}
};

// Reducer para manejar las acciones del formulario
function formReducer(state, action) {
	console.log('TORO Reducer - Acción recibida:', action);
	console.log('TORO Reducer - Estado actual:', state);

	switch (action.type) {
		case 'UPDATE_FIELD':
			// Si la sección es 'tipoSubtipoProyecto', manejarlo de manera especial
			if (action.section === 'tipoSubtipoProyecto') {
				return {
					...state,
					[action.form]: {
						...state[action.form],
						[action.section]: action.value
					}
				};
			} else if (action.section === 'array_obras_expediente') {
				return {
					...state,
					[action.form]: {
						...state[action.form],
						[action.section]: action.value
					}
				};
			} else if (action.section === 'arrayPagosMejoras') {
				return {
					...state,
					[action.form]: {
						...state[action.form],
						[action.section]: action.value
					}
				};
			} else if (action.section === 'arrayPagosMicrocreditos') {
				return {
					...state,
					[action.form]: {
						...state[action.form],
						[action.section]: action.value
					}
				};
			} else if (action.section === 'arrayPagosIntervencionSocial') {
				return {
					...state,
					[action.form]: {
						...state[action.form],
						[action.section]: action.value
					}
				};
			} else if (action.section === 'arrayPagosCapacitaciones') {
				return {
					...state,
					[action.form]: {
						...state[action.form],
						[action.section]: action.value
					}
				};
			} else if (action.section === 'arrayPagosProyectos') {
				return {
					...state,
					[action.form]: {
						...state[action.form],
						[action.section]: action.value
					}
				};
			} else if (action.section === 'arrayMediciones') {
				return {
					...state,
					[action.form]: {
						...state[action.form],
						[action.section]: action.value
					}
				};
			} else if (action.section === 'arrayMejorasEtapaI') {
				return {
					...state,
					[action.form]: {
						...state[action.form],
						[action.section]: action.value
					}
				};
			} else if (action.section === 'arrayMejorasEtapaII') {
				return {
					...state,
					[action.form]: {
						...state[action.form],
						[action.section]: action.value
					}
				};
			} else if (action.section === 'arrayCircuitoAdmin') {
				return {
					...state,
					[action.form]: {
						...state[action.form],
						[action.section]: action.value
					}
				};
			} else if (action.section === 'arrayBeneficiarios') {
				return {
					...state,
					[action.form]: {
						...state[action.form],
						[action.section]: action.value
					}
				};
			} else if (action.section === 'arrayMediciones') {
				return {
					...state,
					[action.form]: {
						...state[action.form],
						[action.section]: action.value
					}
				};
			} else if (action.section === 'arrayMejorasEtapaI') {
				return {
					...state,
					[action.form]: {
						...state[action.form],
						[action.section]: action.value
					}
				};
			} else if (action.section === 'arrayMejorasEtapaII') {
				return {
					...state,
					[action.form]: {
						...state[action.form],
						[action.section]: action.value
					}
				};
			} else if (action.section === 'porcentaje_parcial_2do_pago') {
				return {
					...state,
					[action.form]: {
						...state[action.form],
						[action.section]: action.value
					}
				};
			} else if (action.section === 'porcentaje_parcial_3er_pago') {
				return {
					...state,
					[action.form]: {
						...state[action.form],
						[action.section]: action.value
					}
				};
			} else if (action.section === 'porcentaje_gastos_operativos') {
				return {
					...state,
					[action.form]: {
						...state[action.form],
						[action.section]: action.value
					}
				};
			} else if (action.section === 'habilitarMultiplesPartidos' || action.section === 'partidosSeleccionados' ||
				action.section === 'barriosSeleccionados' ||
				action.section === 'tiposBarrioSeleccionados' || action.section === 'barriosRENABAPSeleccionados' ||
				action.section === 'barrioOtroNombres') {
				// Campos al nivel de formA (no dentro de datosGenerales)
				return {
					...state,
					[action.form]: {
						...state[action.form],
						[action.section]: action.value
					}
				};
			}
			// Para campos normales dentro de secciones
			const nuevoEstadoSeccion = {
				...state[action.form][action.section],
				[action.field]: action.value
			};

			// Auto-prefix 'EI - ' para Mejoras Habitacionales etapa I
			if (action.section === 'datosGenerales' && (['modalidad', 'programa_lineamiento', 'area_responsable', 'nombre_obra'].includes(action.field))) {
				const area = action.field === 'area_responsable' ? action.value : nuevoEstadoSeccion.area_responsable;
				const programa = action.field === 'programa_lineamiento' ? action.value : nuevoEstadoSeccion.programa_lineamiento;
				const modalidad = action.field === 'modalidad' ? action.value : nuevoEstadoSeccion.modalidad;
				const nombreObra = nuevoEstadoSeccion.nombre_obra || '';

				if (
					area === 'ÁREA DE MEJORAS' &&
					programa === 'Mejoras Habitacionales Trabajar en la Casa' &&
					modalidad === 'etapa I' &&
					!nombreObra.startsWith('EI -')
				) {
					nuevoEstadoSeccion.nombre_obra = 'EI - ' + (nombreObra || '');
				}
			}

			return {
				...state,
				[action.form]: {
					...state[action.form],
					[action.section]: nuevoEstadoSeccion
				}
			};

		case 'UPDATE_FORM_DATA':
			console.log('TORO Reducer - Procesando UPDATE_FORM_DATA');
			console.log('TORO Reducer - form:', action.form);
			console.log('TORO Reducer - data:', action.data);
			console.log('TORO Reducer - Estado actual de formA:', state[action.form]);

			// Auto-prefix 'EI - ' al cargar datos existentes
			const datosProcesados = { ...action.data };
			if (datosProcesados.datosGenerales) {
				const dg = datosProcesados.datosGenerales;
				const nombreObra = dg.nombre_obra || '';
				if (
					dg.area_responsable === 'ÁREA DE MEJORAS' &&
					dg.programa_lineamiento === 'Mejoras Habitacionales Trabajar en la Casa' &&
					dg.modalidad === 'etapa I' &&
					!nombreObra.startsWith('EI -')
				) {
					datosProcesados.datosGenerales = {
						...dg,
						nombre_obra: 'EI - ' + nombreObra
					};
				}

				// cg_03_tipo_subsidio tiene dos capitalizaciones en la base
				// ("Subsidio a municipio" y "Subsidio a Municipio"). Se
				// normaliza al cargar, una sola vez, para que todos los
				// `=== 'Subsidio a ONG'` que hay repartidos en el codigo
				// sigan funcionando sin tocar 40 comparaciones.
				const tipoNorm = normalizarTipoSubsidio(dg.tipo_subsidio);
				if (tipoNorm !== dg.tipo_subsidio) {
					datosProcesados.datosGenerales = {
						...(datosProcesados.datosGenerales || dg),
						tipo_subsidio: tipoNorm
					};
				}

				// Los contactos de una obra siempre se manejan como array en el
				// form, aunque en la base esten como objeto unico o texto plano
				// (obra cargada antes de la migracion 062). Se pasa ya
				// normalizado para que ningun consumidor tenga que parsear.
				const { contactos } = parsearContactosObra(dg.contacto_proyecto);
				datosProcesados.datosGenerales = {
					...(datosProcesados.datosGenerales || dg),
					contacto_proyecto: JSON.stringify(contactos)
				};
			}

			const newState = {
				...state,
				[action.form]: {
					...state[action.form],
					...datosProcesados
				},
				dirtySections: {
					formA: false,
					formB_main: false,
					formB_observaciones: false,
					formB_expedienteProyecto: false,
					formB_tramitacionExterna: false,
					formC_main: false,
					formC_pagos: false,
					formC_mediciones: false,
					formC_mejoras: false,
					formC_geometries: false,
					formC_beneficiarios: false,
					formC_circuitoAdmin: false
				},
				dirtyFields: {}
			};
			console.log('TORO Reducer - Nuevo estado:', newState);
			return newState;

		case 'UPDATE_OBSERVACION':
			// Mantener compatibilidad con el código existente
			const updatedObservaciones = {
				...state.formB.observaciones,
				[action.observacionType]: action.value
			};

			// Mapear a la nueva estructura
			const observacionesMapping = {
				reporteEntidad: 'observacionesReporteEntidad',
				internas: 'observacionesInternas',
				tramitacionExterna: 'observacionesTramitacionExterna'
			};

			const updatedFormB = {
				...state.formB,
				observaciones: updatedObservaciones
			};

			// Actualizar el campo correspondiente en la nueva estructura
			if (observacionesMapping[action.observacionType]) {
				updatedFormB[observacionesMapping[action.observacionType]] = action.value;
			}

			return {
				...state,
				formB: updatedFormB
			};

		case 'UPDATE_TRAMITACIONES':
			// Mantener compatibilidad con el código existente
			const updatedTramitaciones = {
				...state.formB.tramitaciones,
				[action.tramitacionType]: action.value
			};

			// Mapear a la nueva estructura
			const tramitacionesMapping = {
				internas: 'tramitacionesInternas',
				externas: 'tramitacionesExternas'
			};

			const updatedFormBTramitaciones = {
				...state.formB,
				tramitaciones: updatedTramitaciones
			};

			// Actualizar el campo correspondiente en la nueva estructura
			if (tramitacionesMapping[action.tramitacionType]) {
				updatedFormBTramitaciones[tramitacionesMapping[action.tramitacionType]] = action.value;
			}

			return {
				...state,
				formB: updatedFormBTramitaciones
			};

		case 'UPDATE_FORM_B':
			// Actualización directa de cualquier campo en formB
			return {
				...state,
				formB: {
					...state.formB,
					...action.payload
				}
			};

		//case for UPDATE_FROM_C
		case 'UPDATE_FORM_C':
			return {
				...state,
				formC: {
					...state.formC,
					...action.payload
				}
			};

		case 'SET_ACTIVE_TAB':
			return {
				...state,
				activeTab: action.tabId
			};

		case 'VALIDATE_FORM':
			return {
				...state,
				validation: {
					...state.validation,
					[action.form]: {
						isValid: action.isValid,
						errors: action.errors || {}
					}
				}
			};

		case 'SET_DIRTY':
			return {
				...state,
				dirtySections: {
					...state.dirtySections,
					[action.section]: true
				}
			};

		case 'SET_DIRTY_FIELD':
			return {
				...state,
				dirtyFields: {
					...state.dirtyFields,
					[action.fieldKey]: true
				}
			};

		case 'RESET_DIRTY':
			return {
				...state,
				dirtySections: {
					formA: false,
					formB_main: false,
					formB_observaciones: false,
					formB_expedienteProyecto: false,
					formB_tramitacionExterna: false,
					formC_main: false,
					formC_pagos: false,
					formC_mediciones: false,
					formC_mejoras: false,
					formC_geometries: false,
					formC_beneficiarios: false,
					formC_circuitoAdmin: false
				},
				dirtyFields: {}
			};

		case 'RESET_FORM':
			return initialState;

		default:
			console.warn('Reducer - Acción no manejada:', action.type);
			return state;
	}
}

export const FormProvider = ({ children }) => {
	const [state, dispatch] = useReducer(formReducer, initialState);
	console.log("STATE", state)

	// Ref para suprimir SET_DIRTY durante carga inicial de edición.
	// FormProvider es el ancestro de todos los consumidores, por lo que su
	// useEffect se ejecuta DESPUÉS de los efectos hijos (React orden bottom‑up).
	// Esto permite que loadingRef = true durante el render de los hijos y que
	// el reset a false ocurra solo cuando todos los efectos de auto‑población
	// ya hayan tenido oportunidad de dispararse.
	const loadingRef = useRef(false);

	// Agrega un efecto para rastrear cambios en el estado
	useEffect(() => {
		console.log('TORO FormProvider - Estado actualizado:', state);
		console.log('TORO FormProvider - formA actual:', state.formA);
		console.log('TORO FormProvider - formB actual:', state.formB);
		console.log('TORO FormProvider - formC actual:', state.formC);
	}, [state]);

	// loadingRef ya no se resetea automáticamente con microtask.
	// Se resetea manualmente desde InicioPage cuando formC (y opcionalmente formB)
	// terminan de cargarse, evitando que auto‑correcciones en efectos hijos
	// (p.ej. disabled en pagos, captura de porcentajes parciales) marquen dirty
	// prematuramente mientras formB/formC aún se están cargando (async).

	// Mapear (form, section) a clave de dirtySections
	function getDirtyKey(form, section) {
		if (form === 'formA') {
			if (section === 'arrayBeneficiarios') return 'formC_beneficiarios';
			return 'formA';
		}
		if (form === 'formB') {
			if (section === 'internasHistorico') return 'formB_observaciones';
			if (section === 'expedienteProyecto') return 'formB_expedienteProyecto';
			return 'formB_main';
		}
		if (form === 'formC') {
			if (['arrayPagosMejoras', 'arrayPagosMicrocreditos', 'arrayPagosProyectos', 'arrayPagosIntervencionSocial', 'arrayPagosCapacitaciones',
				'porcentaje_parcial_2do_pago', 'porcentaje_parcial_3er_pago', 'porcentaje_gastos_operativos'
			].includes(section)) return 'formC_pagos';
			if (section === 'arrayMediciones') return 'formC_mediciones';
			if (section === 'arrayMejorasEtapaI' || section === 'arrayMejorasEtapaII') return 'formC_mejoras';
			if (section === 'arrayCircuitoAdmin') return 'formC_circuitoAdmin';
			return 'formC_main';
		}
		return null;
	}

	// Actualizar un campo del formulario
	const updateField = useCallback((form, section, field, value) => {
		// Helper para despachar SET_DIRTY solo si no estamos en carga inicial
		const setDirty = (sectionKey) => {
			if (!loadingRef.current) {
				if (sectionKey === 'formA') {
					console.trace('[DEBUG] SET_DIRTY formA - loadingRef is false');
				}
				dispatch({ type: 'SET_DIRTY', section: sectionKey });
				const fieldKey = field ? `${form}.${section}.${field}` : `${form}.${section}`;
				dispatch({ type: 'SET_DIRTY_FIELD', fieldKey });
			}
		};
		console.log('updateField - Antes de dispatch:', { form, section, field, value });

		/*if (section === 'arrayPagosMejoras') {
			
			dispatch({
				type: 'UPDATE_FIELD',
				form,
				section: 'arrayPagosMejoras',
				value: Array.isArray(value) ? value : [value]
			});
		} 
		*/

		// Casos especiales para formA
		if (form === 'formA') {
			if (section === 'tipoSubtipoProyecto') {
				setDirty(getDirtyKey(form, section));
				return dispatch({
					type: 'UPDATE_FIELD',
					form,
					section: 'tipoSubtipoProyecto',
					value: Array.isArray(value) ? value : [value]
				});
			}
			if (section === 'array_obras_expediente') {
				setDirty(getDirtyKey(form, section));
				return dispatch({
					type: 'UPDATE_FIELD',
					form,
					section: 'array_obras_expediente',
					value: Array.isArray(value) ? value.filter(Boolean) : (value ? [value] : [])
				});
			}
			if (section === 'arrayBeneficiarios') {
				setDirty(getDirtyKey(form, section));
				return dispatch({
					type: 'UPDATE_FIELD',
					form,
					section: 'arrayBeneficiarios',
					value: Array.isArray(value) ? value : (value ? [value] : [])
				});
			}
		}

		// Casos para formB
		if (form === 'formB') {
			// Si es un campo de tramitaciones internas
			if (section === 'tramitacionesInternas' && field) {
				setDirty(getDirtyKey(form, section));
				return dispatch({
					type: 'UPDATE_FORM_B',
					payload: {
						tramitacionesInternas: {
							...state.formB.tramitacionesInternas,
							[field]: value
						}
					}
				});
			}
			// Expediente de proyecto (checkboxes)
			if (section === 'expedienteProyecto') {
				setDirty(getDirtyKey(form, section));
				return dispatch({
					type: 'UPDATE_FORM_B',
					payload: {
						expedienteProyecto: Array.isArray(value) ? value : []
					}
				});
			}
			// selectedRequisitos: objeto anidado field → value
			// NOTA: usa UPDATE_FIELD en lugar de UPDATE_FORM_B para evitar stale closure
			// (updateField tiene useCallback([], []) → state queda congelado al montar)
			if (section === 'selectedRequisitos' && field) {
				setDirty(getDirtyKey(form, section));
				return dispatch({
					type: 'UPDATE_FIELD',
					form,
					section,
					field,
					value
				});
			}
			// Para campos directos de formB
			else if (field && !state.formB[section]) {
				setDirty(getDirtyKey(form, section));
				return dispatch({
					type: 'UPDATE_FORM_B',
					payload: {
						[section]: value
					}
				});
			}
		}

		//Casos para formC
		if (form === 'formC') {
			//agregar casos para arrayPagosMejoraas
			if (section === 'arrayPagosMejoras') {
				setDirty(getDirtyKey(form, section));
				return dispatch({
					type: 'UPDATE_FIELD',
					form,
					section: 'arrayPagosMejoras',
					value: Array.isArray(value) ? value : [value]
				});
			} else if (section === 'arrayPagosMicrocreditos') {
				setDirty(getDirtyKey(form, section));
				return dispatch({
					type: 'UPDATE_FIELD',
					form,
					section: 'arrayPagosMicrocreditos',
					value: Array.isArray(value) ? value : [value]
				});
			} else if (section === 'arrayPagosProyectos') {
				setDirty(getDirtyKey(form, section));
				return dispatch({
					type: 'UPDATE_FIELD',
					form,
					section: 'arrayPagosProyectos',
					value: Array.isArray(value) ? value : [value]
				});
			} else if (section === 'arrayPagosIntervencionSocial') {
				setDirty(getDirtyKey(form, section));
				return dispatch({
					type: 'UPDATE_FIELD',
					form,
					section: 'arrayPagosIntervencionSocial',
					value: Array.isArray(value) ? value : [value]
				});
			} else if (section === 'arrayPagosCapacitaciones') {
				setDirty(getDirtyKey(form, section));
				return dispatch({
					type: 'UPDATE_FIELD',
					form,
					section: 'arrayPagosCapacitaciones',
					value: Array.isArray(value) ? value : [value]
				});
			} else if (section === 'arrayMediciones') {
				setDirty(getDirtyKey(form, section));
				return dispatch({
					type: 'UPDATE_FIELD',
					form,
					section: 'arrayMediciones',
					value: Array.isArray(value) ? value : [value]
				});
			} else if (section === 'arrayMejorasEtapaI') {
				setDirty(getDirtyKey(form, section));
				return dispatch({
					type: 'UPDATE_FIELD',
					form,
					section: 'arrayMejorasEtapaI',
					value: Array.isArray(value) ? value : [value]
				});
			} else if (section === 'arrayMejorasEtapaII') {
				setDirty(getDirtyKey(form, section));
				return dispatch({
					type: 'UPDATE_FIELD',
					form,
					section: 'arrayMejorasEtapaII',
					value: Array.isArray(value) ? value : [value]
				});
			} else if (section === 'arrayCircuitoAdmin') {
				setDirty(getDirtyKey(form, section));
				return dispatch({
					type: 'UPDATE_FIELD',
					form,
					section: 'arrayCircuitoAdmin',
					value: Array.isArray(value) ? value : [value]
				});
			} else if (section === 'porcentaje_parcial_2do_pago') {
				setDirty(getDirtyKey(form, section));
				return dispatch({
					type: 'UPDATE_FIELD',
					form,
					section: 'porcentaje_parcial_2do_pago',
					value
				});
			} else if (section === 'porcentaje_parcial_3er_pago') {
				setDirty(getDirtyKey(form, section));
				return dispatch({
					type: 'UPDATE_FIELD',
					form,
					section: 'porcentaje_parcial_3er_pago',
					value
				});
			} else if (section === 'porcentaje_gastos_operativos') {
				setDirty(getDirtyKey(form, section));
				return dispatch({
					type: 'UPDATE_FIELD',
					form,
					section: 'porcentaje_gastos_operativos',
					value
				});
			} else if (section === 'seguimientoObra') {
				setDirty(getDirtyKey(form, section));
				return dispatch({
					type: 'UPDATE_FIELD',
					form,
					section,
					field,
					value
				});
			}
		}

		// Comportamiento por defecto (campos anidados)
		setDirty(getDirtyKey(form, section));
		return dispatch({
			type: 'UPDATE_FIELD',
			form,
			section,
			field,
			value
		});


	}, []);//state.formA, state.formB
	//NOTA para mi yo del futuro:  // DEJAR Sin dependencias para evitar recreaciones innecesarias

	// Marcar una sección como sucia manualmente (suprimido durante carga inicial)
	const markSectionDirty = useCallback((section) => {
		if (!loadingRef.current) {
			dispatch({ type: 'SET_DIRTY', section });
			dispatch({ type: 'SET_DIRTY_FIELD', fieldKey: section });
		}
	}, []);

	// Resetear todas las secciones sucias post-save
	const resetDirtySections = useCallback(() => {
		dispatch({ type: 'RESET_DIRTY' });
	}, []);

	// Actualizar datos completos de un formulario
	const updateFormData = useCallback((form, data) => {
		console.log('updateFormData - Antes de dispatch:', { form, data });
		dispatch({
			type: 'UPDATE_FORM_DATA',
			form,
			data
		});
	}, []);

	const updateFormB = useCallback((updates, dirtySection) => {
		dispatch({ type: 'SET_DIRTY', section: dirtySection || 'formB_main' });
		dispatch({
			type: 'UPDATE_FORM_B',
			payload: updates
		});
	}, []);

	// Carga de datos que NO marca dirtySections (para usar durante carga inicial de edición)
	const loadFormB = useCallback((updates) => {
		dispatch({
			type: 'UPDATE_FORM_B',
			payload: updates
		});
	}, []);

	//updateFormC
	const updateFormC = useCallback((updates) => {
		dispatch({ type: 'SET_DIRTY', section: 'formC_main' });
		dispatch({
			type: 'UPDATE_FORM_C',
			payload: updates
		});
	}, []);

	// Carga de datos de formC que NO marca dirtySections
	const loadFormC = useCallback((updates) => {
		dispatch({
			type: 'UPDATE_FORM_C',
			payload: updates
		});
	}, []);

	// Carga de campo individual que NO marca dirtySections (carga inicial de edición)
	const loadField = useCallback((form, section, field, value) => {
		dispatch({
			type: 'UPDATE_FIELD',
			form,
			section,
			field,
			value
		});
	}, []);

	// Actualizar observaciones
	const updateObservacion = useCallback((observacionType, value) => {
		const fieldMap = {
			'reporteEntidad': 'observacionesReporteEntidad',
			'internas': 'observacionesInternas',
			'tramitacionExterna': 'observacionesTramitacionExterna'
		};

		const field = fieldMap[observacionType];
		if (!field) {
			console.warn(`Tipo de observación no reconocido: ${observacionType}`);
			return;
		}

		dispatch({ type: 'SET_DIRTY', section: 'formB_observaciones' });
		dispatch({
			type: 'UPDATE_FORM_B',
			payload: {
				observaciones: {
					...(state.formB?.observaciones || {}),
					[observacionType]: value
				}
			}
		});
	}, [state.formB?.observaciones]);

	// Actualizar trámites
	const updateTramitaciones = useCallback((tipo, value) => {
		// Mapeo de tipos de trámites a los nombres de campo en formB
		const fieldMap = {
			'internas': 'tramitacionesInternas',
			'externas': 'tramitacionesExternas'
		};

		const field = fieldMap[tipo];
		if (!field) {
			console.warn(`Tipo de trámite no reconocido: ${tipo}`);
			return;
		}

		if (!loadingRef.current) {
			const dirtySection = field === 'tramitacionesExternas' ? 'formB_tramitacionExterna' : 'formB_main';
			dispatch({ type: 'SET_DIRTY', section: dirtySection });
		}
		dispatch({
			type: 'UPDATE_FORM_B',
			payload: {
				[field]: value
			}
		});
	}, []);

	// Para actualizar:
	const updateTramitacionInterna = useCallback((value) => {
		dispatch({ type: 'SET_DIRTY', section: 'formB_main' });
		dispatch({
			type: 'UPDATE_FORM_B',
			payload: {
				tramitacion: value
			}
		});
	}, []);

	// Cambiar pestaña activa
	const setActiveTab = useCallback((tabId) => {
		dispatch({
			type: 'SET_ACTIVE_TAB',
			tabId
		});
	}, []);

	// Validar formulario
	const validateForm = useCallback((form, isValid, errors = {}) => {
		dispatch({
			type: 'VALIDATE_FORM',
			form,
			isValid,
			errors
		});
	}, []);

	// Resetear formulario
	const resetForm = useCallback(() => {
		dispatch({ type: 'RESET_FORM' });
	}, []);

	// Función para depuración
	const debugContext = () => {
		console.group('Debug FormContext');
		console.log('Estado completo:', state);
		console.log('formA:', state.formA);
		console.log('datosGenerales:', state.formA?.datosGenerales);
		console.log('tipoSubtipoProyecto:', state.formA?.tipoSubtipoProyecto);
		console.log('array_obras_expediente:', state.formA?.array_obras_expediente);
		console.log('arrayPagosMejoras:', state.formC?.arrayPagosMejoras);
		console.groupEnd();
	};

	// Marcar carga inicial como completa (libera SET_DIRTY)
	const loadingComplete = useCallback(() => {
		loadingRef.current = false;
	}, []);

	// Agrega esto al value del provider
	const contextValue = useMemo(() => ({
		...state,
		updateField,
		updateFormData,
		updateFormB,
		loadFormB,
		updateFormC,
		loadFormC,
		loadField,
		debugContext,
		updateObservacion,
		updateTramitaciones,
		updateTramitacionInterna,
		setActiveTab,
		validateForm,
		resetForm,
		markSectionDirty,
		resetDirtySections,
		loadingRef,
		loadingComplete
	}), [state, updateField, updateFormData, updateFormB, loadFormB, updateFormC, loadFormC, loadField, updateObservacion, updateTramitaciones, updateTramitacionInterna, setActiveTab, validateForm, resetForm, markSectionDirty, resetDirtySections, loadingComplete]);

	return (
		<FormContext.Provider
			value={contextValue}
		/*value={{
			...state, // Aquí se incluye formA, formB, formC, activeTab, validation
			updateField, // Aquí se incluye la función updateField
			updateFormData,
			updateObservacion,
			updateTramitaciones,
			setActiveTab,
			validateForm,
			resetForm
		}}*/
		>
			{children}
			{/* Botón de depuración (puedes eliminarlo después) */}
			{/*<button
				onClick={debugContext}
				style={{
					position: 'fixed',
					bottom: '20px',
					right: '20px',
					zIndex: 9999,
					padding: '10px',
					background: '#f00',
					color: '#fff',
					border: 'none',
					borderRadius: '4px',
					cursor: 'pointer'
				}}
			>
				Debug Context
			</button>*/}
		</FormContext.Provider>
	);
};

export const useFormContext = () => {
	const context = useContext(FormContext);
	if (!context) {
		throw new Error('useFormContext debe usarse dentro de un FormProvider');
	}
	return context;
};